/* eslint-disable @typescript-eslint/no-explicit-any */
import { createSlice, nanoid, PayloadAction } from '@reduxjs/toolkit';

export interface ToastMessageProps {
 message: string | null;
 type: 'info' | 'success' | 'warning' | 'error';
 id?: string | number;
}
export interface ToastState {
 messages?: ToastMessageProps[];
}

const initialState: ToastState = {
 messages: [],
 //  message: null,
 //  type: 'info',
};

const toastSlice = createSlice({
 name: 'toast',
 initialState,
 reducers: {
  displayToast(state, action: PayloadAction<ToastMessageProps>) {
   if (!state.messages) {
    state.messages = [];
   }
   state.messages.push({
    message: action.payload.message,
    type: action.payload.type,
    id: nanoid(),
   });
  },
  clearToast(state, action: PayloadAction<string | number>) {
   if (state.messages) {
    const filtered = [...(state.messages || [])]?.filter((message) => {
     return message.id?.toString() !== action.payload.toString();
    });
    state.messages = filtered;
   }
  },
 },
});

export const { displayToast, clearToast } = toastSlice.actions;

export default toastSlice.reducer;
